import React from 'react';

const PdfViewBase = ({ base64 }) => {
  // Create the data URL from the base64 string
  const pdfData = `data:application/pdf;base64,${base64}`;

  return (
    <iframe
      src={pdfData}
      type="application/pdf"
      width="100%"
    //   height="100%"
      title="PDF Viewer"
      style={{height: "431px"}}
    >
      <p>Your browser does not support iframes. Download the PDF to view it: <a href={pdfData}>Download PDF</a>.</p>
    </iframe>
  );
};

export default PdfViewBase;
